import { HttpClientModule } from '@angular/common/http';
import { Component, Inject } from '@angular/core';

import { ConfigurationModule } from '@sondermind/configuration';
import { LoggingInitModule } from '@sondermind/logging-init';

import { ILaunchDarklyUser, LAUNCH_DARKLY_SERVICE, LaunchDarklyService } from '@sondermind/launch-darkly';
import { DirectoryPage } from './components/directory-page/directory-page.component';

@Component({
  standalone: true,
  imports: [
    ConfigurationModule,
    DirectoryPage,
    HttpClientModule,
    LoggingInitModule,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    @Inject(LAUNCH_DARKLY_SERVICE)
    private launchDarklyService: LaunchDarklyService,
  ) {
    this.initLaunchDarklyClient();
  }

  private initLaunchDarklyClient() {
    this.launchDarklyService.initClient(this.buildNewLaunchDarklyClient());
  }

  private buildNewLaunchDarklyClient(): ILaunchDarklyUser {
    return {
      kind: 'anonUserId',
      anonymous: true,
    };
  }
}
